import { render } from "./Index.vue?vue&type=template&id=a81283a8"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=a81283a8&lang=css"
script.render = render

export default script